// extracted by mini-css-extract-plugin
module.exports = {"EndCallButton":"EndCallButton-module__EndCallButton___33UwY"};